/* eslint-disable no-unused-vars */
import { call, put, takeLatest, select, delay } from 'redux-saga/effects';
import {
  FETCH_ASSESSMENT_REPORT_AND_DOWNLOAD,
  SIGNUP_ON_RELOAD,
  FETCH_USER_DETAILS,
  SAVE_CURRENT_USER,
  FETCH_ASSESSMENT_REPORT_DETAILS,
  FETCH_CASE_DETAILS,
  PROCESS_CASE_AND_GET_DETAILS,
} from 'redux/actions/actionTypes';
import { actionsCreator } from 'redux/actions/actionsCreator';
//apis
import { userAPIs, gatewayAPIs, proxyAPIs, lifelineAPIs, participantAPIs } from 'api';
//utils
import get from 'lodash/get';
import { toast } from 'react-toastify';
import { downloadPDF } from 'utils/downloadHelper';
//events
import events from 'appAnalytics';
import { reportProfileKey, reportUrlKey, reportUserKey } from '../../assets/Constants';
const getStateObj = ({ user, config, report, caseData }) => ({
  user,
  config,
  report,
  caseData,
});

function* getAssessmentReportAndDownload(action) {
  try {
    // Fetch caseId and other details from redux
    const { /* user = {}, */ report = {} } = yield select(getStateObj);
    const assessmentName = get(report, 'context.assessmentName', 'Assessment-Report')
      .toString()
      .toUpperCase();
    // const dateNow = new Date();
    // const guestPDFName = `${assessmentName}-Assessment-${dateNow.getTime()}.pdf`;
    // const userName = get(user, 'name', null) || get(user, 'guestUser.name', '');
    // const isGuestUser = get(user, 'isGuestUser', true);
    const caseId = get(report, 'caseId', '');
    //const pdfName = isGuestUser ? guestPDFName : `${userName}'s-assessment.pdf`;
    // const pdfName = guestPDFName;
    if (caseId) {
      yield put(actionsCreator.SET_ASSESSMENT_REPORT_DOWNLOAD_LOADER(true));
      // Call lifeline to get the report
      const {
        data: { /* base64: pdfData = null, */ url: pdfUrl = '' } = {},
      } = yield call(lifelineAPIs.getAssessmentReport, { caseId });
      // download the PDF file using base64 data
      downloadPDF(pdfUrl, `${assessmentName}-report.pdf`);
      //downloadBase64DataPDF(pdfData, pdfName);
    } else {
      toast.error('Unable to fetch case ID for Assessment report PDF download');
    }
    yield put(actionsCreator.SET_ASSESSMENT_REPORT_DOWNLOAD_LOADER(false));
  } catch (error) {
    let errMsg = get(
      error,
      'response.data.message',
      'Error while fetching assessmnet report and downloading'
    );
    toast.error('Unable to download report');
    yield put(actionsCreator.SET_ASSESSMENT_REPORT_DOWNLOAD_LOADER(false));

    const errObj = get(error, 'response.data', {});
    events.errorMsg.apiError({
      apiName: 'getAssessmentReportAndDownload',
      errorResponse: { ...errObj },
    });

    console.error('Error while Login', errMsg);
    console.error(error);
  } finally {
    // comment added to handle linting error
  }
}

function* signupGuestUser(action) {
  try {
    const { payload } = action;
    yield put(actionsCreator.AUTHENTICATE_USER({ isUserAuthenticated: false }));
    yield put(actionsCreator.SHOW_SKELETON_REPORT_LOADER(true));
    const { data: userData = {} } = yield call(userAPIs.signupGuestUser, payload);
    const { userId, profileId } = userData;
    const { name, age, gender } = payload;
    yield put(
      actionsCreator.STORE_USER_INFO({
        name,
        age,
        gender,
        isGuestUser: true,
        userId: userId,
        profileId: profileId,
      })
    );

    yield put(actionsCreator.AUTHENTICATE_USER({ isUserAuthenticated: true }));

    //Register Guest User Device
    // const deviceInfo = prepareRegisterPayload(userId);
    // yield call(commsAPIs.registerUserDevice, deviceInfo);
  } catch (error) {
    console.error('Error while Login', error);
    const errObj = get(error, 'response.data', {});
    events.errorMsg.apiError({ apiName: 'signupGuestUser', errorResponse: { ...errObj } });
  } finally {
    yield put(actionsCreator.SHOW_SKELETON_REPORT_LOADER(false));
  }
}

function* fetchUserDetailsAndConfig(action) {
  try {
    const { data } = yield call(participantAPIs.fetchUserDetailsAPI);
    const userData = data[0];
    yield put(actionsCreator.AUTHENTICATE_USER({ isUserAuthenticated: false }));
    yield put(actionsCreator.SHOW_SKELETON_REPORT_LOADER(true));
    const { user = {} } = yield select(getStateObj);
    const { profileId, profileSelected } = user;
    const userObj = {
      name: userData.name,
      age: userData.age,
      gender: userData.gender,
      userId: userData.userId,
      profileId: userData.id,
    };
    if (profileId && profileSelected) {
      userObj['profileId'] = profileId;
    }
    yield put(actionsCreator.STORE_USER_INFO(userObj));
    yield put(actionsCreator.AUTHENTICATE_USER({ isUserAuthenticated: true }));
  } catch (error) {
    console.error('Error while Login', error);
    const errObj = get(error, 'response.data', {});
    events.errorMsg.apiError({ apiName: 'signupGuestUser', errorResponse: { ...errObj } });
  } finally {
    yield put(actionsCreator.SHOW_SKELETON_REPORT_LOADER(false));
  }
}

function* saveCurrentUser(action) {
  try {
    const { payload } = action;
    yield put(actionsCreator.AUTHENTICATE_USER({ isUserAuthenticated: false }));
    yield put(actionsCreator.SHOW_SKELETON_REPORT_LOADER(true));

    yield call(proxyAPIs.saveUserInfo, payload);

    const { userId, profiles = [], urlSelectedProfileId } = payload;

    const selectedProfileIndex = profiles.findIndex(profile => {
      return profile.id === urlSelectedProfileId;
    });

    if (selectedProfileIndex !== -1) {
      const { name, gender } = profiles[selectedProfileIndex];
      yield put(
        actionsCreator.STORE_USER_INFO({
          name,
          gender,
          userId: userId,
          profileId: urlSelectedProfileId,
          isGuestUser: false,
        })
      );
    } else {
      yield put(
        actionsCreator.STORE_USER_INFO({
          userId: userId,
          profileId: urlSelectedProfileId,
          isGuestUser: false,
        })
      );
    }

    yield put(actionsCreator.AUTHENTICATE_USER({ isUserAuthenticated: true }));

    //Register Actual User's Device
    // const deviceInfo = prepareRegisterPayload(userId);
    // yield call(commsAPIs.registerUserDevice, deviceInfo);
  } catch (error) {
    console.error('Error while Login', error);

    const errObj = get(error, 'response.data', {});
    events.errorMsg.apiError({ apiName: 'signupGuestUser', errorResponse: { ...errObj } });
  } finally {
    yield put(actionsCreator.SHOW_SKELETON_REPORT_LOADER(false));
  }
}

function* getAssessmentReportDetails(action) {
  try {
    yield put(actionsCreator.SHOW_SIGNUP_GUEST_AND_PROCESS_CASE_LOADER(true));
    const { channel = '' } = action.payload;
    const { caseData = {}, report = {} } = yield select(getStateObj);
    const { caseId } = caseData;
    const cId = caseId;
    //const cId = caseId || payloadCaseId;
    const payload = {
      caseId: cId,
      channel,
    };
    if (['v6'].includes(report?.reportType)) {
      payload.version = report.reportType;
    }

    const { data: assessmentDetails = {} } = yield call(lifelineAPIs.getAssessmentDetails, payload);
    yield put(actionsCreator.STORE_ASSESSMENT_REPORT_DETAILS(assessmentDetails));
    //yield delay(2000);
    yield put(actionsCreator.SHOW_SIGNUP_GUEST_AND_PROCESS_CASE_LOADER(false));
    try {
      const baseUrl = window.location.origin + window.location.pathname;
      const params = `?rs=${assessmentDetails.context.rs}&channel=website&uid=${assessmentDetails.userId}&sp=${assessmentDetails.profileId}&caseId=${assessmentDetails.caseId}`;
      const reportUrl = baseUrl + params;
      sessionStorage.setItem(reportUrlKey, reportUrl);
      sessionStorage.setItem(reportUserKey, assessmentDetails.userId);
      sessionStorage.setItem(reportProfileKey, assessmentDetails.profileId);
    } catch (error) {
      console.error('Error in forming resport url ::', error);
    }
  } catch (error) {
    console.error('Error in getAssessmentReportDetails ::', error);
    const errObj = get(error, 'response.data', {});
    events.errorMsg.apiError({
      apiName: 'getAssessmentReportDetails',
      errorResponse: { ...errObj },
    });
    yield put(actionsCreator.SHOW_SIGNUP_GUEST_AND_PROCESS_CASE_LOADER(false));
  }
}

function* processCaseAndGetDetails(action) {
  const allowedRetryCounts = 2;
  try {
    yield put(actionsCreator.SHOW_SKELETON_REPORT_LOADER(false));
    yield put(actionsCreator.SHOW_SIGNUP_GUEST_AND_PROCESS_CASE_LOADER(true));
    const { payload } = action;
    const { user = {} } = yield select(getStateObj);
    const { userId, profileId, isGuestUser } = user;
    const { context, isCaseDetailsRequired } = payload;

    const assessmentConfig = get(context, 'assessmentConfig', {});
    const processCasePayload = {
      ...assessmentConfig,
      context,
      profileId: profileId,
      userId: userId,
      language: 'EN', // have to handle later
    };

    // Show stacking gif loader
    yield put(actionsCreator.SHOW_SKELETON_REPORT_LOADER(false));
    yield put(actionsCreator.SHOW_SIGNUP_GUEST_AND_PROCESS_CASE_LOADER(true));

    const { data: processCaseData = {} } = yield call(gatewayAPIs.processCase, processCasePayload);
    const caseId = get(processCaseData, 'caseId', '');
    const chatRoomId = get(processCaseData, 'chatRoomId', '');

    if (!isGuestUser) {
      yield call(lifelineAPIs.updateSelfCheckReport, {
        caseId,
        isActive: true,
      });
    }

    let caseDetails = {};

    if (isCaseDetailsRequired) {
      /**
       * Only fetchCaseDetails in case of MFine chat based assessments like COVID-19
       */
      const caseDetailsResponse = yield call(lifelineAPIs.fetchCaseDetails, { caseId });
      caseDetails = caseDetailsResponse.data;
    }

    yield put(actionsCreator.STORE_CASE_INFO({ chatRoomId, caseId, caseDetails }));
    yield put(actionsCreator.TOGGLE_PROCESS_CASE_LOADER(false));
    yield put(actionsCreator.TOGGLE_COMPLETE_FLOW_LOADER(false));
  } catch (error) {
    console.error('Error in process Case  ::', error);
    const errObj = get(error, 'response.data', {});
    //API-Failure Retry Logic
    const { payload } = action;
    const { retryCount = 1 } = payload;
    if (retryCount <= allowedRetryCounts) {
      events.errorMsg.apiError({
        apiName: 'processConsultation',
        retryCount,
        errorResponse: { ...errObj },
      });

      yield delay(1000);
      yield put(
        actionsCreator.PROCESS_CASE_AND_GET_DETAILS({
          ...action.payload,
          retryCount: retryCount + 1,
        })
      );
    } else {
      yield put(actionsCreator.SHOW_SIGNUP_GUEST_AND_PROCESS_CASE_LOADER(false));
    }
    //API-Failure Retry Logic
  }
}

function* fetchCaseDetails(action) {
  try {
    const { caseId, chatRoomId } = action.payload;
    yield put(actionsCreator.TOGGLE_PROCESS_CASE_LOADER(true));
    const caseDetailsResponse = yield call(lifelineAPIs.fetchCaseDetails, { caseId });
    const caseDetails = caseDetailsResponse.data;
    yield put(actionsCreator.TOGGLE_PROCESS_CASE_LOADER(false));
    yield put(actionsCreator.STORE_CASE_INFO({ chatRoomId, caseId, caseDetails }));
  } catch (error) {
    console.error('Error in fetching Case Details ::', error);
    const errObj = get(error, 'response.data', {});
    events.errorMsg.apiError({ apiName: 'fetchCaseDetails', errorResponse: { ...errObj } });
    yield put(actionsCreator.SHOW_SIGNUP_GUEST_AND_PROCESS_CASE_LOADER(false));
  }
}

export default function* assessmentReportsSagas() {
  yield takeLatest(FETCH_ASSESSMENT_REPORT_AND_DOWNLOAD, getAssessmentReportAndDownload);
  yield takeLatest(SIGNUP_ON_RELOAD, signupGuestUser);
  yield takeLatest(FETCH_USER_DETAILS, fetchUserDetailsAndConfig);
  yield takeLatest(SAVE_CURRENT_USER, saveCurrentUser);
  yield takeLatest(FETCH_ASSESSMENT_REPORT_DETAILS, getAssessmentReportDetails);
  yield takeLatest(FETCH_CASE_DETAILS, fetchCaseDetails);
  yield takeLatest(PROCESS_CASE_AND_GET_DETAILS, processCaseAndGetDetails);
}
